import {Uszkodzenie} from '../../../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {StrategiaComponent} from './strategia.component';
import {SlownikUszkodzen} from '../../../../../../../../shared/model/uszkodzenia/slownik-uszkodzen';

@Component({
  templateUrl: './strategia-rodzaj-material-wartosc.component.html'
})
export class StrategiaRodzajMaterialWartoscComponent implements StrategiaComponent {

  language = window.navigator.language

  @Input()
  slownikUszkodzen!: SlownikUszkodzen;

  @Input()
  uszkodzenie!: Uszkodzenie<any>;

  @Output()
  public usunUszkodzenieClick = new EventEmitter<{identyfikatorUszkodzenia: string}>()

  usunUszkodzenie(event: {identyfikatorUszkodzenia: string}): void {
    this.usunUszkodzenieClick.emit(event)
  }

  getRodzajPowierzchni(uszkodzenie: Uszkodzenie<any>): string {
    const rodzajPowierzchni = uszkodzenie.elementyUszkodzone
      .find(elementUszkodzony => elementUszkodzony.rodzaj === 'rodzajPowierzchni')?.opis;
    return rodzajPowierzchni ? rodzajPowierzchni : '-';
  }

  getMaterialWykonczenia(uszkodzenie: Uszkodzenie<any>): string {
    const materialWykonczenia = uszkodzenie.elementyUszkodzone
      .find(elementUszkodzony => elementUszkodzony.rodzaj === 'materialWykonczenia')?.opis;
    return materialWykonczenia ? materialWykonczenia : '-';
  }
}
